/**
 * Root application component.
 * Sets up routing and provides auth context to the entire app.
 */

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Modules from './pages/Modules';
import ModulePage from './pages/ModulePage';
import Settings from './pages/Settings';
import CashFlow from './pages/CashFlow';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route path="cashflow" element={<CashFlow />} />
            <Route path="modules" element={<Modules />} />
            <Route path="modules/:slug" element={<ModulePage />} />
            <Route path="settings" element={<Settings />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
